class PlaylistStatus {
	static Invalid = 0;
	static Ready = 1;
	static Current = 2;
	static Played = 3;
	static NotPlayed = 4;
	static Paused = 6;
	static BackgroundAutoStart = 7;
	static BackgroundPaused = 8;
}

export default PlaylistStatus;